var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts,"items-per-page":5}})
}
var staticRenderFns = []

export { render, staticRenderFns }